import e, { useContext as t } from "react";

var n,
    i = (n = n || Object.create(null), {
  on: function on(e, t) {
    (n[e] || (n[e] = [])).push(t);
  },
  off: function off(e, t) {
    n[e] && n[e].splice(n[e].indexOf(t) >>> 0, 1);
  },
  emit: function emit(e, t) {
    (n[e] || []).slice().map(function (e) {
      e(t);
    }), (n["*"] || []).slice().map(function (n) {
      n(e, t);
    });
  }
}),
    r = e.createContext({
  emitter: i
}),
    c = function c(t) {
  return e.createElement(r.Provider, {
    value: {
      emitter: i
    }
  }, t.children);
},
    o = function o() {
  return t(r);
};

export { c as MittProvider, o as useMitt };